htm<template>
	<div class="parent">
		<div class="scroll">
			<table class="hidetabledynamic"><tr><td class="hidetabledynamic">

				<table class="hidetable" style="table-layout:fixed; display: table; float:left">
					<tr>
						<td class="hidetable" style="width:100px;"><div style="float:right">Employees</div></td>
						<td class="hidetable" style="table-layout:fixed; width:500px" colspan=3>
							<autocomplete
							id="employeeSearch"
							v-model="employeeSearch"
							:type="28"
							v-on:finish="setData"
							style="width:100%;"
							></autocomplete>
						</td>
						<td class="hidetable" style="width:50px;">
							<button v-on:click="addEmployee()" style="height:30px; width:40px;"><font-awesome-icon icon="user-plus" /></button>
						</td>
						<td class="hidetable" style="width:50px;">
							<button v-on:click="addAllEmployees()" style="height:30px; width:40px;"><font-awesome-icon icon="users" /></button>
						</td>
						<td class="hidetable" colspan="2">
							<div v-for="(employeeName, i) in employeeNames" :key="JSON.stringify(employeeName)">
								<button v-bind:id="'employee'+i" class="employeebox" v-on:click="removeEmployee(i)">
									{{employeeName}}
								</button>
							</div>
						</td>
					</tr>
					<tr>
						<td class="hidetable "><div style="float:right">From</div></td>
						<td class="hidetable">
							<input
					        id="startDate"
					        type="date"
					        class="date"
							v-model="startDate"
					        style="height:25px; width:100%"
					        >
						</td>
						<td class="hidetable "><div style="float:right;">To</div></td>
						<td class="hidetable">
							<input
							id="endDate"
							type="date"
							class="date"
							v-model="endDate"
							style="height:25px; width:100%"
							>
						</td>
						<td class="hidetable ">
							<button v-on:click="newDates(true)" style="height:30px; width:40px;"><font-awesome-icon icon="check" /></button>
						</td>
						<td class="hidetable ">
							<button v-on:click="toggleShowEmpty()" style="height:30px; width:40px;">
								<font-awesome-icon v-if="showEmpty==true" icon="toggle-on" />
								<font-awesome-icon v-else icon="toggle-off" />
							</button>
						</td>
					</tr>
				</table>
			</td><td class="hidetabledynamic">
				<div>
					<table style="font-size:12px">
						<tr>
							<td style="padding:3px;height:0px;font-weight:bold">Legend</td>
							<td v-for="(i) in colorList.length/3" style="padding:3px;height:0px">{{colorList[(i-1)*3][0].substr(0,5)}}</td>
						</tr>
						<tr v-for="(i) in 3">
							<td v-if="i==1" style="padding:3px;height:0px">Completed</td>
							<td v-else-if="i==2" style="padding:3px;height:0px">Open</td>
							<td v-else-if="i==3" style="padding:3px;height:0px">Cancelled</td>

							<td v-for="(j) in colorList.length/3" style="padding:3px;height:0px">
								<div v-bind:style="{ width:'20px', height:'20px', background:'#'+colorList[((j-1)*3)+(i-1)][2], border: '1px solid #000000' }"></div>
							</td>
						</tr>
					</table>
				</div>
			</td></tr></table>

			<div v-if="overview==false" ref="timechart">
				<div v-for="(employeeId, i) in employeeIds" :key="JSON.stringify(employeeId)">
					<div v-for="(date, j) in dates">
						<timetable :id=id :timeTableID=(j+i*dates.length) :employeeID=employeeId :employeeName=employeeNames[i] :showEmpty="showEmpty" :searchDate="date" style="width:100%; height:auto;"></timetable>
					</div>
				</div>
			</div>
			<div v-else ref="timechart">
					<div v-for="(date, j) in dates">
						<timetable-overview :id=id :timeTableID=(j) :employeeIDS=employeeIds :showEmpty="showEmpty" :searchDate="date" style="width:100%; height:auto;"></timetable-overview>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        id: Number,
		term: String,
		path:String,
		overview: {
			type: Boolean,
			required: false,
			default: false
		},
    },
	data() {
		return {
			employeeIds:[],
			employeeNames:[],
			terms:[],
			dates:[],
			startDate:'',
			endDate:'',
			employeeSearch:'',
			colorList:[],
			showEmpty:true,
		}
	},
	async created (){
		this.getColors()

		this.setEmployees();

		let stateCheck = setInterval(() => {
			if (document.readyState === 'complete') {
				clearInterval(stateCheck);
				this.setDates();
			}
		}, 100);
	},
	methods:{
		setDates(){
			var date = new Date();
			var millis = 86400000;
			if(this.endDate==''){
				this.endDate = (date.getFullYear()+"-"+('0'+(date.getMonth()+1)).slice(-2)+"-"+('0'+date.getDate()).slice(-2));
			}
			date.setTime(date.getTime() - millis*14);
			if(this.startDate==''){
				this.startDate = (date.getFullYear()+"-"+('0'+(date.getMonth()+1)).slice(-2)+"-"+('0'+date.getDate()).slice(-2));
			}
			this.newDates(false);
		},
		newDates(reload){
			this.dates=[];
			var now = new Date().getTime();
			var millis = 86400000 * 7;
			var newStartDate = new Date(this.getFirstDate(this.startDate));
			var newEndDate = new Date(this.getFirstDate(this.endDate)); // tthis.endDate
			var startTime = newStartDate.getTime();
			var endTime = newEndDate.getTime();
			endTime+=1000;
			var timeIterator = startTime;
			do{
				if(timeIterator>now+86400000){
					timeIterator+=millis;
					continue;
				}
				var dateIterator = new Date();
				dateIterator.setTime(timeIterator);
				this.dates.unshift(dateIterator.getFullYear()+"-"+(dateIterator.getMonth()+1)+"-"+dateIterator.getDate());
				timeIterator+=millis;
			}while(timeIterator<=endTime)

			//console.log(this.dates)

			if(reload) { this.reload() }
		},
		getFirstDate(dayOfWeek){
			//console.log("------------------")
			var millis = 86400000;
			var date = new Date(dayOfWeek);
			//console.log(date)
			var dayNum = date.getDay()-2;
			//console.log(dayNum)
			date.setTime(date.getTime() - (millis*dayNum));
			//console.log(date)
			return(date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate());
		},
		setData(index, value){
			this.employeeSearch = value;
		},
		toggleShowEmpty(){
			this.showEmpty = !this.showEmpty;
			this.reload()
		},
		addEmployee(){
			if(this.employeeSearch!=undefined&&this.employeeSearch!=''){
				this.terms.push(this.employeeSearch);
				this.employeeIds.push(parseInt(this.employeeSearch.split('•')[0]))
				this.employeeNames.push(this.employeeSearch.split('•')[1])

				this.reload()
			}
		},
		addAllEmployees(){

			this.removeAllEmployees()
			this.showEmpty=false;

			api.postData(
				{
					type:"search",
					data:{
						pageid:this.id,
						all:true,
						data:[

						]
					}
				}
			).then((res) => {
				for(let i = 0;i<res.data.data.column_data.length;i++){
					let val = res.data.data.column_data[i][0]
					this.terms.push(val);
					this.employeeIds.push(parseInt(val.split('•')[0]))
					this.employeeNames.push(val.split('•')[1])
				}
				this.reload()
			});
		},
		removeAllEmployees(){
			this.terms.splice(0, this.terms.length)
			this.employeeIds.splice(0, this.employeeIds.length)
			this.employeeNames.splice(0, this.employeeNames.length)
		},
		removeEmployee(index){
			this.terms.splice(index, 1)
			this.employeeIds.splice(index, 1)
			this.employeeNames.splice(index, 1)

			this.reload()
		},
		setEmployees(){
			if(this.term==null || this.term==''){
				return;
			}
			var split = this.term.split(';')
			if(split[0]!=''){
				var employeeSplit = split[0].split(',')
				for(var i = 0;i<employeeSplit.length;i++){
					this.terms.push(employeeSplit[i]);

					this.employeeIds.push(parseInt(this.terms[i].split('•')[0]))
					this.employeeNames.push(this.terms[i].split('•')[1])
				}
			}

			this.startDate = split[1]
			this.endDate = split[2]
			this.showEmpty = split[3]=='true'
		},
		reload(){
			router.push('/'+this.path+'?q='+this.terms.toString()+';'+this.startDate+';'+this.endDate+';'+this.showEmpty)
			router.go(0)
		},
		getColors(){
			api.getData("employee/colors").then((res) => {
				this.colorList = res.data.data.column_data;
			});
		}
	},
}
</script>

<style scoped>
.hidetable{
	table-layout:fixed;
	background-color: #ffffff;
	border-collapse: collapse;
	border: 0px solid black;
	empty-cells: show;
}
.hidetabledynamic{
	background-color: #ffffff;
	border-collapse: collapse;
	border: 0px solid black;
	empty-cells: show;
}
.employeebox{
	float:left;
	margin:1px;
	height:30px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout_4.vue